<template>
  <div class="text-input-root" :class="containerClass">
    <div
      class="text-input-container"
      :style="inputStyle"
      :class="{ error: error }"
    >
      <label class="text-input-label" :class="{ selected: value }" :for="name">
        {{ currentLabel
        }}<span v-if="!value && required" class="text-input-asterisk">*</span>
      </label>

      <svg-select-input-arrow></svg-select-input-arrow>

      <select
        style="opacity: 0; width: 100%; cursor: pointer"
        :name="name"
        :id="name"
        @input="$emit('input', $event.target.value)"
        @change="handleChange"
        @focus="handleFocus"
        @blur="
          $emit('blur', $event.target.value);
          isFocused = false;
        "
      >
        <slot></slot>
      </select>
    </div>

    <div
      class="text-input-error"
      v-if="error"
      role="alert"
      aria-live="assertive"
    >
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  name: "select-input",
  data() {
    return {
      isFocused: false,
      currentLabel: this.label,
    };
  },
  props: {
    containerClass: String,
    inputStyle: Object,
    error: [String, Boolean],
    label: String,
    name: {
      type: String,
      required: true,
    },
    required: Boolean,
    value: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleFocus() {
      this.isFocused = true;
    },
    handleChange(e) {
      const select = e.target;
      const selectedOption = select.querySelector("option:checked");
      if (selectedOption) {
        const label = selectedOption.textContent;
        this.currentLabel = label;
      }
    },
  },
};
</script>
